import ProxyClass from "proxyclass";

export default new (class Settings extends ProxyClass {
  constructor() {
    super();
  }
  _get(target, property) {
    let settings = JSON.parse(localStorage.getItem("settings"));
    return settings[property];
  }
  _set(target, property, value) {
    let settings = JSON.parse(localStorage.getItem("settings"));
    settings[property] = value;
    localStorage.setItem("settings", JSON.stringify(settings));
    return true;
  }
})();